// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5570":"3d1d8164","6232":"75e787bd"}[chunkId] + ".chunk.css";
};